import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const a = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, l = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  d: "M12.845 3.195a1.583 1.583 0 0 1 2.704 1.53L14.15 8.922a.25.25 0 0 0 .237.329H21c.966 0 1.75.784 1.75 1.75v1.764c0 .272-.063.54-.185.783l-3.618 7.236a1.75 1.75 0 0 1-1.565.967H9a1.72 1.72 0 0 1-.25-.018v.018H3A1.75 1.75 0 0 1 1.25 20v-9c0-.966.784-1.75 1.75-1.75h4.655l.016-.019 5.174-6.036ZM8.75 10.37V20c0 .138.112.25.25.25h8.382a.25.25 0 0 0 .224-.138l3.618-7.236a.25.25 0 0 0 .026-.112V11a.25.25 0 0 0-.25-.25h-6.613a1.75 1.75 0 0 1-1.66-2.303l1.399-4.196a.083.083 0 0 0-.142-.08L8.81 10.207a.25.25 0 0 0-.06.163Zm-1.5.38v9.5H3a.25.25 0 0 1-.25-.25v-9a.25.25 0 0 1 .25-.25h4.25Z",
  "clip-rule": "evenodd"
}, null, -1), c = [
  l
];
function n(r, d) {
  return e(), t("svg", a, [...c]);
}
const h = { render: n };
export {
  h as default,
  n as render
};
